import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/free-public-self-storage.jpg'),
    alt: 'free public self storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'free public self storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Find <span>Free</span><span>Public Self Storage Solutions</span>',
  description:
    'Store your belongings free in our secure self-storage units. Whether for days or months, we offer hassle-free, cost-free storage for everyone.',
  image: {
    url: '/images/v2/pages/landing-pages/free-public-self-storage/hero-image.jpg',
    alt: 'Find Free Public Self Storage Solutions'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Free Public Storage Now' }
}

export const ourProcessSectionContent = {
  title: 'How Free Public Self Storage Works',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/free-public-self-storage/how-free-public-self-storage-works.png',
    alt: 'How Free Public Self Storage Works'
  },

  articles: [
    {
      id: 1,
      title: 'Simple Booking Process',
      description:
        "Reserve your free public self-storage unit online in minutes. Choose your preferred location, size, and duration - It's quick and easy!",
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/simple-booking-process.png',
        alt: 'Simple Booking Process'
      }
    },
    {
      id: 2,
      title: 'Security You Can Trust',
      description:
        'Rest easy knowing your items are safe in our well-maintained, monitored storage units with round-the-clock security.',
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/security-you-can-trust.png',
        alt: 'Security You Can Trust'
      }
    },
    {
      id: 3,
      title: 'Easy Access to Your Belongings',
      description:
        'Our self-storage units are available whenever you need them, giving you the freedom to access your items as needed.',
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/easy-access-to-your-belongings.png',
        alt: 'Easy Access to Your Belongings'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Safe and Free Public Self Storage',
  description:
    'With ShipAndStorage, our free public self-storage units offer a secure and convenient way to store your belongings. We make sure your items are well cared for, giving you peace of mind during your storage period.',
  image: {
    src: '/images/v2/pages/landing-pages/free-public-self-storage/safe-and-free-public-self-storage.jpg',
    alt: 'Safe and Free Public Self Storage'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Free Public Self Storage',

  cards: [
    {
      id: 1,
      title: 'Cost-Free Storage',
      description: 'Take advantage of our free public self-storage units - no fees, no hidden costs.',
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/cost-free-storage.png',
        alt: 'Cost-Free Storage'
      }
    },
    {
      id: 2,
      title: 'Flexible Storage Plans',
      description:
        'Whether you need space for a few weeks or months, we offer flexible options to suit your storage needs.',
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/flexible-storage-plans.png',
        alt: 'Flexible Storage Plans'
      }
    },
    {
      id: 3,
      title: 'Convenient Access',
      description:
        'Access your stored items at any time during business hours, making it easy to retrieve what you need.',
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/convenient-access.png',
        alt: 'Convenient Access'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Free Public Self Storage?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Renters and Homeowners',
          description:
            'Need temporary storage while moving or renovating? Our free public self-storage units are ideal for homeowners and renters alike.'
        },
        {
          id: 2,
          title: 'College Students',
          description:
            'Students can store their belongings during summer breaks or while transitioning between semesters without paying a dime.'
        },
        {
          id: 3,
          title: 'Small Businesses',
          description:
            'Store inventory, documents, or equipment in a secure, free public self-storage unit to keep your business organized.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/who-should-use-free-public-self-storage.jpg',
        alt: 'Who Should Use Free Public Self Storage?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Other Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description:
        'Need to store office inventory or files? Our business storage options offer secure and affordable solutions.',
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Enjoy the flexibility of our free public self-storage units while you transition to a new home or apartment.',
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship luggage or boxes locally and internationally with ease and without any hidden fees.',
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Keep your home organized during renovations, relocations, or long vacations with our free storage options.',
      image: {
        src: '/images/v2/pages/landing-pages/free-public-self-storage/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Free Public Self Storage?',

  image: {
    url: '/images/v2/pages/landing-pages/free-public-self-storage/why-choose-shipandstorage-for-free-public-self-storage.jpg',
    alt: 'Why Choose ShipAndStorage for Free Public Self Storage?'
  },

  articles: [
    {
      id: 1,
      title: 'Convenient and Cost-Free',
      description:
        'Enjoy the flexibility of public self-storage with no fees. Simply store your belongings and retrieve them whenever needed.'
    },
    {
      id: 2,
      title: 'Flexible Storage Solutions',
      description: 'Store your items for as long as you need, with no minimum or maximum term requirements.'
    },
    {
      id: 3,
      title: 'Transparent and Clear Terms',
      description:
        'We pride ourselves on transparent storage terms. There are no hidden fees or surprise costs, what you see is what you get.'
    },
    {
      id: 4,
      title: 'Easy Access to Your Items',
      description:
        'We offer convenient access hours to ensure you can retrieve your belongings at a time that works best for you.'
    },
    {
      id: 5,
      title: 'Top-Tier Security',
      description: 'Your belongings are stored in a highly secure facility with 24/7 surveillance and access control.'
    },
    {
      id: 6,
      title: 'Temporary and Long-Term Storage',
      description:
        "Whether you're storing for a short time or an extended period, our free public self-storage units are the perfect solution."
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Find Free Public Self Storage Solutions Near You Today',
  description:
    'Find free public self-storage solutions near you today. Secure, affordable options for storing your items at no cost.',
  image: {
    src: '/images/v2/pages/landing-pages/free-public-self-storage/find-free-public-self-storage-solutions-near-you-today.png',
    alt: 'Find Free Public Self Storage Solutions Near You Today'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Claim Your Storage Space ' }
}

export const ourPartnersSectionContent = {
  title: 'Our Shipping Partners',
  description: 'ShipAndStorage collaborates with trusted partners to ensure top-quality public self-storage services.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx is a leader in shipping and logistics, ensuring your items are handled with care during transport and storage.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides secure and reliable global logistics, ensuring safe storage and transportation of your belongings.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS is a trusted name in logistics and storage, providing secure storage solutions for businesses and individuals alike.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
